export default __webpack_public_path__ + "static/media/Coinbase5.c1246543.png";